var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSymbol = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB00",
    d: "M10.587454 23.060336H8.820842c-4.416528 0-8.010668 3.59414-8.010668 8.041127v24.032004c0 4.416528 3.59414 8.010668 8.010668 8.010668h1.766612c4.416528 0 8.010668-3.59414 8.010668-8.010668V31.101463c0-4.446987-3.59414-8.041127-8.010668-8.041127z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2979FF",
    d: "M55.1487.825401H31.055778c-4.446987 0-8.010668 3.59414-8.010668 8.010668v1.766612c0 4.416528 3.59414 8.010668 8.010668 8.010668h24.123381c4.416528 0 8.010668-3.59414 8.010668-8.010668V8.836069C63.159368 4.419541 59.565228.825401 55.1487.825401z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F80046",
    d: "M10.617913.825401H8.820843c-4.416528 0-8.010668 3.59414-8.010668 8.010668v1.766612c0 4.416528 3.59414 8.010668 8.010668 8.010668h1.766612c4.416528 0 8.010668-3.59414 8.010668-8.010668V8.83607c.030459-4.416528-3.533222-8.010668-7.980209-8.010668z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC3E",
    d: "M55.118241 23.060336H31.055778c-4.446987 0-8.010668 3.59414-8.010668 8.041127v24.062463c0 4.416528 3.59414 8.010668 8.010668 8.010668h24.062463c4.416528 0 8.010668-3.59414 8.010668-8.010668V31.101463c0-4.446987-3.59414-8.041127-8.010668-8.041127z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSymbol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/symbol.6a8dc225182c4daf93c1cde4d6c50157.svg";